export default __webpack_public_path__ + "static/media/schema-client.2c78a6d8.graphql";